import { format, startOfMonth, endOfMonth, addMonths, subMonths } from "date-fns";

export const API = '/api';

export const MONTHS = ["Januar","Februar","Maerz","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];

export const WD = {
  Monday:"Mo",Tuesday:"Di",Wednesday:"Mi",Thursday:"Do",Friday:"Fr",Saturday:"Sa",Sunday:"So",
  Montag:"Mo",Dienstag:"Di",Mittwoch:"Mi",Donnerstag:"Do",Freitag:"Fr",Samstag:"Sa",Sonntag:"So",
};

export const STATUS_OPTS = [
  { value: "arbeitstag", label: "Arbeitstag" },
  { value: "urlaub", label: "Urlaub" },
  { value: "krank", label: "Krank" },
  { value: "feiertag", label: "Feiertag" },
  { value: "frei", label: "Frei" },
];

export const PAUSE_OPTS = [0, 15, 30, 45, 60];

export const GRUND_OPTS = [
  { value: "", label: "–" },
  { value: "wohnort_projekt", label: "Wohnort → Projekt" },
  { value: "projekt_hotel", label: "Projekt → Hotel" },
  { value: "hotel_projekt", label: "Hotel → Projekt" },
  { value: "projekt_wohnort", label: "Projekt → Wohnort" },
  { value: "sonstiges", label: "Sonstiges" },
];

export const hm = (m) => {
  const v = Math.abs(m || 0);
  return `${Math.floor(v / 60)}:${(v % 60).toString().padStart(2, "0")}`;
};

export const toM = (t) => {
  if (!t) return 0;
  const [h, m] = String(t).split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const TODAY = format(new Date(), "yyyy-MM-dd");

export function mkRange(key) {
  const [y, m] = key.split("-").map(Number);
  const d = new Date(y, m - 1, 1);
  return { from: format(startOfMonth(d), "yyyy-MM-dd"), to: format(endOfMonth(d), "yyyy-MM-dd") };
}

export function mkKey(d) { return format(d, "yyyy-MM"); }

export function mkPrev(k) {
  const [y, m] = k.split("-").map(Number);
  return mkKey(subMonths(new Date(y, m - 1, 1), 1));
}

export function mkNext(k) {
  const [y, m] = k.split("-").map(Number);
  return mkKey(addMonths(new Date(y, m - 1, 1), 1));
}

export const TH = "text-left text-[9px] font-semibold px-1.5 py-2 leading-tight";
export const thBorder = { borderRight: "1px solid var(--tga-border)", color: "var(--tga-text-dim)" };
export const thGroupBorder = { borderRight: "2px solid var(--tga-border-strong)", color: "var(--tga-text-dim)" };
export const tdS = { height: 38, borderRight: "1px solid var(--tga-border)" };
export const tdGS = { height: 38, borderRight: "2px solid var(--tga-border-strong)" };
export const plainSelect = "w-full h-full bg-transparent text-[12px] border-none outline-none cursor-pointer appearance-none px-0";

export const COL_DEFS = [
  { key: "wt", label: "WT", w: 32 },
  { key: "act", label: "", w: 36 },
  { key: "datum", label: "Datum", w: 80 },
  { key: "status", label: "Status", w: 92, ge: true },
  { key: "projekt", label: "Projekt", w: 160, ge: true },
  { key: "fhkm", label: "Hinfahrt KM", w: 82 },
  { key: "fhz", label: "Hinfahrt Zeit", w: 82 },
  { key: "gh", label: "Grund Hinfahrt", w: 100, ge: true },
  { key: "von", label: "Von", w: 50 },
  { key: "bis", label: "Bis", w: 50 },
  { key: "pause", label: "Pause", w: 50 },
  { key: "arbeit", label: "Arbeitszeit", w: 80, ge: true },
  { key: "frkm", label: "Rueckfahrt KM", w: 88 },
  { key: "frz", label: "Rueckfahrt Zeit", w: 88 },
  { key: "gr", label: "Grund Rueckfahrt", w: 105, ge: true },
  { key: "soll", label: "Soll", w: 48 },
  { key: "ist", label: "Ist", w: 48 },
  { key: "diff", label: "+/-", w: 52, ge: true },
  // Neue Abrechnungs-Spalten (07.02.2026)
  { key: "vma",        label: "VMA",         w: 60 },
  { key: "nacht",      label: "Übernacht.",  w: 64 },
  { key: "unterkunft", label: "Unterkunft",  w: 110 },
  { key: "abger",      label: "Abger.",      w: 56 },
];

export const LS_KEY = "stundenkonten_col_widths";

export function loadColWidths() {
  try {
    const s = localStorage.getItem(LS_KEY);
    if (s) { const o = JSON.parse(s); if (typeof o === "object") return o; }
  } catch {}
  return {};
}

export function saveColWidths(w) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(w)); } catch {}
}
